import { isEmpty } from "lodash";

import ExpandableLinks from "../../../../../components/ExpandableItems/ExpandableLinks/ExpandableLinks";
import MultiSelectWithAdditionField from "../../../../../components/forms/MultiSelectWithAdditionField";

import { ValidatedForm } from "../../../../../components/forms";
import { type NormalizedDropdown } from "../../../../../utils/miscellaneousUtils";

import { type FormikProps } from "formik";
import { type TagsPayloadCamelPlural } from "../../../../../interfaces/Tags";
import { type Settings } from "../../types/models";

import styles from "./settingsForm.module.scss";

export interface SettingsFormProps {
  isDisabled: boolean;
  isLoading?: boolean;
  entityId: number;
  settings: Settings;
  tagsFormik: FormikProps<Settings>;
  normalizedTags?: TagsPayloadCamelPlural;
  updateTags: (id: number, tags: string[], type: "labels" | "softwareApplications") => void;
}

const SettingsForm = (props: SettingsFormProps) => {
  const handleTagChange = async (
    field: "softwareApplications" | "labels",
    value: NormalizedDropdown,
    shouldValidate?: boolean,
  ) => {
    const errors = await props.tagsFormik.setFieldValue(field, value.selected, shouldValidate);
    if (isEmpty(errors?.[field])) {
      props.updateTags(props.entityId, value.selected, field);
    }
  };

  const renderFields = () => {
    const { isDisabled, normalizedTags } = props;
    return (
      <div className={styles.root}>
        <div className={styles["settings-fields"]}>
          <MultiSelectWithAdditionField
            {...props.tagsFormik}
            isCaseSensitive
            shouldValidate
            label="Software Application"
            propertyName="softwareApplications"
            disabled={isDisabled}
            options={normalizedTags?.softwareApplications}
            value={props.tagsFormik.values.softwareApplications}
            setFieldValue={handleTagChange}
          />
          <MultiSelectWithAdditionField
            {...props.tagsFormik}
            isCaseSensitive
            shouldValidate
            label="Labels"
            propertyName="labels"
            disabled={isDisabled}
            options={normalizedTags?.labels}
            value={props.tagsFormik.values.labels}
            setFieldValue={handleTagChange}
          />

          <ExpandableLinks
            label="Associated Flows"
            linkFormatter={(id) => `/content/flows/${id}/items`}
            iconName="fa-code-branch"
            links={props.settings.flows}
          />
        </div>
      </div>
    );
  };
  return (
    <ValidatedForm withoutFormik isLoading={props.isLoading} formWidthComputer={6} disablePreventTransitionPrompt>
      {renderFields}
    </ValidatedForm>
  );
};
export default SettingsForm;
